var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteTickSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.984.24c.254.254.254.635 0 .864L5.281 7.807a.556.556 0 01-.838 0L.99 4.354c-.254-.229-.254-.61 0-.864a.598.598 0 01.838 0l3.047 3.047L11.146.24a.598.598 0 01.838 0z",
    fill: "#fff"
  })));
}
export default SvgWhiteTickSmall;